/**
 * Modular What's New entries for the "timeTracking" module: today's tasks in the time tracker. `routes` use the real navigation screen names from AppNavigator.jsx.
 *
 * @type {Object[]}
 */
const timeTrackingEntries = [
  {
    id: 'timetracking-todays-tasks-2026-10',
    module: 'timeTracking',
    routes: ['TimeTrackerScreen'],
    date: '2026-10-20',
    version: '4.15.1',
    global: true,
    type: 'feature',
    title: {
      en: "✅ “Today’s tasks” in the time tracker",
      hu: "✅ „Mai feladatok” az időmérőben",
      de: "✅ „Heutige Aufgaben“ in der Zeiterfassung",
      cn: "✅ 时间记录中的“今日任务”",
      ro: "✅ „Sarcinile de azi” în pontaj",
      svn: "✅ »Današnje naloge« v merjenju časa",
    },
    body: {
      en: "The time tracker now lists your open tasks that are due today or overdue, overdue first. Pick one, or start a timer on it with a single tap, instead of hunting for the right project. Up to five of them also appear on the home-screen widgets.",
      hu: "Az időmérő mostantól listázza a mára esedékes vagy lejárt nyitott feladataidat, elöl a lejártakkal. Válassz egyet, vagy egyetlen koppintással indíts rajta időmérőt, ahelyett hogy a megfelelő projektet keresnéd. Legfeljebb öt közülük a kezdőképernyős widgeteken is megjelenik.",
      de: "Die Zeiterfassung listet jetzt Ihre offenen Aufgaben, die heute fällig oder überfällig sind, überfällige zuerst. Wählen Sie eine aus oder starten Sie mit einem Tipp einen Timer darauf, statt das richtige Projekt zu suchen. Bis zu fünf davon erscheinen auch in den Homescreen-Widgets.",
      cn: "时间记录现在会列出今天到期或已逾期的未完成任务，逾期的排在前面。选择其中一项，或一键为它启动计时，无需再去找对应的项目。其中最多五项也会显示在主屏幕小组件上。",
      ro: "Pontajul afișează acum sarcinile tale deschise scadente azi sau întârziate, mai întâi cele întârziate. Alege una sau pornește un cronometru pe ea dintr-o atingere, în loc să cauți proiectul potrivit. Până la cinci dintre ele apar și în widgeturile de pe ecranul principal.",
      svn: "Merjenje časa zdaj prikaže vaše odprte naloge, ki zapadejo danes ali so zamujene, najprej zamujene. Izberite eno ali nanjo z enim dotikom zaženite časovnik, namesto da iščete pravi projekt. Do pet jih je tudi v pripomočkih na začetnem zaslonu.",
    },
  },
];

export default timeTrackingEntries;
